import { useState } from 'react';
import { Link } from 'react-router-dom';
import { SharedQuoteForm } from '@/components/shared-quotes/SharedQuoteForm';
import { SharedQuoteLinkPanel } from '@/components/shared-quotes/SharedQuoteLinkPanel';
import type { SharedQuoteDetail } from '@/services/shared-quotes';

export const AdminCreateSharedQuotePage = () => {
  const [createdQuote, setCreatedQuote] = useState<SharedQuoteDetail | null>(null);

  return (
    <div style={{ maxWidth: '720px' }}>
      {/* Back link */}
      <Link
        to="/admin/shared-quotes"
        style={{
          fontSize: '12px',
          color: 'var(--text-accent)',
          textDecoration: 'none',
          display: 'inline-flex',
          alignItems: 'center',
          gap: '4px',
          marginBottom: '12px',
        }}
      >
        &larr; Back to Shared Quotes
      </Link>

      <h1
        style={{
          fontSize: 'var(--text-2xl)',
          fontWeight: 'var(--font-weight-bold)',
          color: 'var(--text-primary)',
          letterSpacing: 'var(--tracking-tight)',
          marginBottom: 'var(--space-6)',
        }}
      >
        Create Shared Quote
      </h1>

      {createdQuote === null ? (
        <SharedQuoteForm onSuccess={setCreatedQuote} />
      ) : (
        <SharedQuoteLinkPanel
          shareToken={createdQuote.shareToken}
          customerEmail={createdQuote.customerEmail}
        />
      )}
    </div>
  );
};
